export { default as RelatedMediaCard } from "./RelatedMediaCard";
export { default as RelatedMediaList } from "./RelatedMediaList";
